/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppConflictsRouteImport } from './routes/_app/conflicts'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDataDeletionRouteImport } from './routes/_app/data-deletion'
import { Route as AppDevicesRouteImport } from './routes/_app/devices'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppLabsRouteImport } from './routes/_app/labs'
import { Route as AppRegisterRouteImport } from './routes/_app/register'
import { Route as AppUnmatchedRouteImport } from './routes/_app/unmatched'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppWorklistRouteImport } from './routes/_app/worklist'
import { Route as AppAccountPasswordRouteImport } from './routes/_app/account/password'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects.$projectId'
import { Route as AppScreeningsScreeningIdRouteImport } from './routes/_app/screenings.$screeningId'
import { Route as AppScreeningsScreeningIdReportRouteImport } from './routes/_app/screenings.$screeningId_.report'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppConflictsRoute = AppConflictsRouteImport.update({
  id: '/conflicts',
  path: '/conflicts',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDataDeletionRoute = AppDataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesRoute = AppDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppLabsRoute = AppLabsRouteImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => AppRoute,
} as any)
const AppRegisterRoute = AppRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AppRoute,
} as any)
const AppUnmatchedRoute = AppUnmatchedRouteImport.update({
  id: '/unmatched',
  path: '/unmatched',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppWorklistRoute = AppWorklistRouteImport.update({
  id: '/worklist',
  path: '/worklist',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountPasswordRoute = AppAccountPasswordRouteImport.update({
  id: '/account/password',
  path: '/account/password',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppScreeningsScreeningIdRoute =
  AppScreeningsScreeningIdRouteImport.update({
    id: '/screenings/$screeningId',
    path: '/screenings/$screeningId',
    getParentRoute: () => AppRoute,
  } as any)
const AppScreeningsScreeningIdReportRoute =
  AppScreeningsScreeningIdReportRouteImport.update({
    id: '/screenings/$screeningId_/report',
    path: '/screenings/$screeningId/report',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/admin': typeof AppAdminRoute
  '/audit': typeof AppAuditRoute
  '/conflicts': typeof AppConflictsRoute
  '/dashboard': typeof AppDashboardRoute
  '/data-deletion': typeof AppDataDeletionRoute
  '/devices': typeof AppDevicesRoute
  '/integrations': typeof AppIntegrationsRoute
  '/labs': typeof AppLabsRoute
  '/register': typeof AppRegisterRoute
  '/unmatched': typeof AppUnmatchedRoute
  '/users': typeof AppUsersRoute
  '/worklist': typeof AppWorklistRoute
  '/account/password': typeof AppAccountPasswordRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/screenings/$screeningId': typeof AppScreeningsScreeningIdRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/screenings/$screeningId/report': typeof AppScreeningsScreeningIdReportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/admin': typeof AppAdminRoute
  '/audit': typeof AppAuditRoute
  '/conflicts': typeof AppConflictsRoute
  '/dashboard': typeof AppDashboardRoute
  '/data-deletion': typeof AppDataDeletionRoute
  '/devices': typeof AppDevicesRoute
  '/integrations': typeof AppIntegrationsRoute
  '/labs': typeof AppLabsRoute
  '/register': typeof AppRegisterRoute
  '/unmatched': typeof AppUnmatchedRoute
  '/users': typeof AppUsersRoute
  '/worklist': typeof AppWorklistRoute
  '/account/password': typeof AppAccountPasswordRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/screenings/$screeningId': typeof AppScreeningsScreeningIdRoute
  '/projects': typeof AppProjectsIndexRoute
  '/screenings/$screeningId/report': typeof AppScreeningsScreeningIdReportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/conflicts': typeof AppConflictsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/data-deletion': typeof AppDataDeletionRoute
  '/_app/devices': typeof AppDevicesRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/labs': typeof AppLabsRoute
  '/_app/register': typeof AppRegisterRoute
  '/_app/unmatched': typeof AppUnmatchedRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/worklist': typeof AppWorklistRoute
  '/_app/account/password': typeof AppAccountPasswordRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/screenings/$screeningId': typeof AppScreeningsScreeningIdRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/screenings/$screeningId_/report': typeof AppScreeningsScreeningIdReportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/setup'
    | '/admin'
    | '/audit'
    | '/conflicts'
    | '/dashboard'
    | '/data-deletion'
    | '/devices'
    | '/integrations'
    | '/labs'
    | '/register'
    | '/unmatched'
    | '/users'
    | '/worklist'
    | '/account/password'
    | '/projects/$projectId'
    | '/screenings/$screeningId'
    | '/projects/'
    | '/screenings/$screeningId/report'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/setup'
    | '/admin'
    | '/audit'
    | '/conflicts'
    | '/dashboard'
    | '/data-deletion'
    | '/devices'
    | '/integrations'
    | '/labs'
    | '/register'
    | '/unmatched'
    | '/users'
    | '/worklist'
    | '/account/password'
    | '/projects/$projectId'
    | '/screenings/$screeningId'
    | '/projects'
    | '/screenings/$screeningId/report'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/setup'
    | '/_app/admin'
    | '/_app/audit'
    | '/_app/conflicts'
    | '/_app/dashboard'
    | '/_app/data-deletion'
    | '/_app/devices'
    | '/_app/integrations'
    | '/_app/labs'
    | '/_app/register'
    | '/_app/unmatched'
    | '/_app/users'
    | '/_app/worklist'
    | '/_app/account/password'
    | '/_app/projects/$projectId'
    | '/_app/screenings/$screeningId'
    | '/_app/projects/'
    | '/_app/screenings/$screeningId_/report'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conflicts': {
      id: '/_app/conflicts'
      path: '/conflicts'
      fullPath: '/conflicts'
      preLoaderRoute: typeof AppConflictsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-deletion': {
      id: '/_app/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof AppDataDeletionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices': {
      id: '/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AppDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/labs': {
      id: '/_app/labs'
      path: '/labs'
      fullPath: '/labs'
      preLoaderRoute: typeof AppLabsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/register': {
      id: '/_app/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AppRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/unmatched': {
      id: '/_app/unmatched'
      path: '/unmatched'
      fullPath: '/unmatched'
      preLoaderRoute: typeof AppUnmatchedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/worklist': {
      id: '/_app/worklist'
      path: '/worklist'
      fullPath: '/worklist'
      preLoaderRoute: typeof AppWorklistRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/password': {
      id: '/_app/account/password'
      path: '/account/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof AppAccountPasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/screenings/$screeningId': {
      id: '/_app/screenings/$screeningId'
      path: '/screenings/$screeningId'
      fullPath: '/screenings/$screeningId'
      preLoaderRoute: typeof AppScreeningsScreeningIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/screenings/$screeningId_/report': {
      id: '/_app/screenings/$screeningId_/report'
      path: '/screenings/$screeningId/report'
      fullPath: '/screenings/$screeningId/report'
      preLoaderRoute: typeof AppScreeningsScreeningIdReportRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppAuditRoute: typeof AppAuditRoute
  AppConflictsRoute: typeof AppConflictsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDataDeletionRoute: typeof AppDataDeletionRoute
  AppDevicesRoute: typeof AppDevicesRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppLabsRoute: typeof AppLabsRoute
  AppRegisterRoute: typeof AppRegisterRoute
  AppUnmatchedRoute: typeof AppUnmatchedRoute
  AppUsersRoute: typeof AppUsersRoute
  AppWorklistRoute: typeof AppWorklistRoute
  AppAccountPasswordRoute: typeof AppAccountPasswordRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppScreeningsScreeningIdRoute: typeof AppScreeningsScreeningIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppScreeningsScreeningIdReportRoute: typeof AppScreeningsScreeningIdReportRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppAuditRoute: AppAuditRoute,
  AppConflictsRoute: AppConflictsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDataDeletionRoute: AppDataDeletionRoute,
  AppDevicesRoute: AppDevicesRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppLabsRoute: AppLabsRoute,
  AppRegisterRoute: AppRegisterRoute,
  AppUnmatchedRoute: AppUnmatchedRoute,
  AppUsersRoute: AppUsersRoute,
  AppWorklistRoute: AppWorklistRoute,
  AppAccountPasswordRoute: AppAccountPasswordRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppScreeningsScreeningIdRoute: AppScreeningsScreeningIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppScreeningsScreeningIdReportRoute: AppScreeningsScreeningIdReportRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
